<form #form="ngForm" class="motivo-perda-venda-exibicao-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Exibição
            </h6>
            <p class="form-text text-muted">
                Selecione em que momento este motivo deve ser exibido e ficar disponível para ser selecionado
            </p>
        </div> 
        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.perdaVenda" name="perdaVenda" id="perdaVenda">
                    <label class="custom-control-label" for="perdaVenda">Perda de Venda</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo na perda de oportunidades e vendas</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.clienteCongelado" name="clienteCongelado" id="clienteCongelado">
                    <label class="custom-control-label" for="clienteCongelado">Congelamento de Cliente</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo no congelamento de clientes</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.contatoCliente" name="contatoCliente" id="contatoCliente">
                    <label class="custom-control-label" for="contatoCliente">Contato de Cliente</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo no contato de clientes</p>
            </li> 
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.revisaoPedidoOrcamento" name="revisaoPedidoOrcamento" id="revisaoPedidoOrcamento">
                    <label class="custom-control-label" for="revisaoPedidoOrcamento">Revisão de Pedidos e Orçamentos</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo a solicitação de revisões de pedidos e orçamentos</p>
            </li>                                   
        </ul>        
    </div>
</form>
